<p-dialog [visible]="visible()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}"
  [style]="{width: '580px'}" styleClass="no-header-modal" (onHide)="HidePopup()"
  aria-label="cancel-freeze-dialog" data-testid="cancel-freeze-dialog">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="surface-0 relative p-3 md:p-4">
      <div class="fa fa-times text-xl text-600 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="HidePopup()" aria-label="close-dialog-button" data-testid="close-dialog-button">
      </div>
      <div class="text-center">
        <img width="200" src="assets/img/cancel-freeze.svg" alt="{{'FREEZE.FREEZE_CANCEL.IMAGE_TOOLTIP' | translate}}"
          data-testid="cancel-freeze-image" />
          <h4 class="text-lg mb-0 mt-4" data-testid="dialog-header">
            {{'FREEZE.FREEZE_CANCEL.HEADER_CANCELFREEZE' | translate}}
          </h4>
        </div>
      </div>
      <!-- Content -->
      <form [formGroup]="fg" (submit)="CancelFreeze()" data-testid="cancel-freeze-form">
        <!-- Content -->
        <div class="surface-100 p-3">
          <label class="block text-xs text-600 mb-2 font-medium uppercase" data-testid="reason-label">
            {{'FREEZE.FREEZE_CANCEL.LABEL_CANCELFREEZE' | translate}}
          </label>
          <textarea formControlName="reason" pInputTextarea class="p-inputtext-sm w-full h-5rem"
          aria-label="reason-textarea" data-testid="reason-textarea"></textarea>
          @if (ReasonControl?.touched && ReasonControl?.invalid) {
            <app-error-msg [errors]="ReasonControl?.errors"
              [fieldLabel]="'FREEZE.FREEZE_CANCEL.REASON' | translate"
              data-testid="reason-error" />
          }
        </div>
        <!-- Content -->

        <!-- Modal Footer -->
        <div class="lg:px-4 px-2 py-3 border-top-1 border-300 surface-0">
          <div class="flex align-items-center justify-content-between">
            <div class="w-4">
              <p-button label="{{'FREEZE.FREEZE_CANCEL.BUTTON_CANCEL' | translate}}"
                styleClass="p-button-link text-sm" (click)="HidePopup()"
                aria-label="cancel-button" data-testid="cancel-button" />
            </div>
            <div class="w-8 text-right">
              <div class="w-8 text-right">
                <button type="submit" pButton pRipple
                  label="{{'FREEZE.FREEZE_CANCEL.BUTTON_CANCELFREEZE' | translate}}"
                  class="text-sm px-4"
                  [loading]="btnLoading.value"
                aria-label="cancel-freeze-button" data-testid="cancel-freeze-button"></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Footer -->
      </form>
    </ng-template>
  </p-dialog>

  @if (showErrorPopup | async; as show_Popup) {
    <app-errors [visible]="show_Popup" (onHide)="HideErrorPopup($event)"  [errorData]="errorMessages"
      [error]="error" (hideErrorPopup)="HideErrorPopup($event)"
      aria-label="error-dialog" data-testid="error-dialog" />
  }